import React from "react";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";

export function TabPanelCreate(props) {
  const { name, friendlyName, value, attributes, lineItems } = props;

  const includeCustomerNote = attributes.reduce(
    (accumulator, attribute) => accumulator || attribute.name === "customer",
    false
  );

  const includeVendorNote = attributes.reduce(
    (accumulator, attribute) => accumulator || attribute.name === "vendor",
    false
  );

  var includeItemNote = false;
  if (lineItems) {
    includeItemNote = lineItems.reduce(
      (accumulator, attribute) => accumulator || attribute.name === "item",
      false
    );
  }

  var refAttrs = [];
  if (includeCustomerNote) {
    refAttrs.push("Customer");
  }
  if (includeVendorNote) {
    refAttrs.push("Vendor");
  }
  if (includeItemNote) {
    refAttrs.push("Item");
  }

  const refString = refAttrs.join(", ");

  const endpointPhrase =
    refAttrs.length < 2 ? "own API endpoint" : "respective API endpoints";

  return (
    <TabPanel value={value} index={1}>
      <div style={{ width: "66%" }}>
        <h3>Create</h3>
        <p>Creates a new {friendlyName.toLowerCase()}.</p>
        <CodeCard>POST /api/v2/{name.toLowerCase()}</CodeCard>
        <p>
          The post body should include the required fields of the{" "}
          {friendlyName.toLowerCase()} object as well as any optional fields for
          which you wish to supply data. Be sure <b>not</b> to include the id
          field for the {friendlyName.toLowerCase()} object or for the line
          items, as these ids will be assigned by the system.
        </p>
        {refString !== "" && (
          <p>
            Note that new referenced records ({refString}) cannot be created in
            this Create {friendlyName} transaction. New referenced records must
            be first created through their {endpointPhrase}, then referenced
            here by ID when creating the {friendlyName} transaction.
          </p>
        )}
        {name === "Item" && (
          <p>
            Initial inventory can be provided when creating a new item. This is
            done by providing information in the fields below as part of the
            POST request. On submission an adjustment will be created for this
            item with the provided information.
            <CodeCard>
              initialQuantity: 15,
              <br /> initialQuantityDate: "2021-05-20T10:00:00",
              <br /> initialValue: 20.00, <br />
              initialLocation: {'{name: "location name"}'},
            </CodeCard>
          </p>
        )}
        <p>
          A successful call returns the newly created{" "}
          {friendlyName.toLowerCase()}.
        </p>
      </div>
    </TabPanel>
  );
}
